import Button from '../Button';
import { ButtonHTMLAttributes } from 'react';
import { VideoShape } from '@/types';
import { useThrottle } from '@/hooks/use-trottle';
import DownloadVideoSVG from '@/svg/download-video.svg?url';
import classNames from 'classnames';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    activeVideo: VideoShape | null;
};

const DownloadVideoButton = ({ activeVideo }: Props) => {
    const handleDownloadVideo = useThrottle(() => {
        if (!activeVideo) return;

        const videoSource = activeVideo[0]?.src;
        if (!videoSource) return;

        const link = document.createElement('a');
        link.href = videoSource;
        link.download = `video-${Math.floor(Math.random() * 1000)}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, 3000);

    return (
        <div
            className={classNames('download-video-button', {
                'download-video-button--visible': activeVideo,
            })}
        >
            <Button onClick={handleDownloadVideo} disabled={!activeVideo} aria-label="Скачать видео">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={DownloadVideoSVG} alt="" width={24} height={24} className="img-fluid" decoding="async" />
            </Button>
        </div>
    );
};

export default DownloadVideoButton;
